import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { Router, RouterLink } from '@angular/router';
import { RegistrationType } from '../../../../app/register/core/registration';
import { AuthService } from '../../../../services/auth/auth.service';
import { UserProfileTab } from '../../../../app/user/user-page-container/user-page-container.component';
import { PaymentService } from '../../../../services/payment.service';
import { PaymentType } from '../../../models/payment/payment-type';
import { SavePowerPlantFormComponent } from '../save-power-plant-form/save-power-plant-form.component';
import { SavePlantResponse } from '../../../models/analysis/save-plant-response';
import { CalculatorService } from '../calculator.service';

@Component({
  selector: 'psc-pay-for-full',
  standalone: true,
  imports: [CommonModule, SharedModule, TranslocoModule, RouterLink, SavePowerPlantFormComponent],
  templateUrl: './pay-for-full.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayForFullComponent implements OnInit {

  @Input() buttonOnly: boolean = false;
  @Input() analysisId: string | undefined;
  @Input() userId: string | undefined;
  @Input() paymentType: PaymentType.HomeAnalysis | PaymentType.EnterpriseAnalysis = PaymentType.HomeAnalysis;
  url: string;
  queryParams: any;

  constructor(
    public authService: AuthService,
    public router: Router,
    public paymentService: PaymentService,
    public calculatorService: CalculatorService,
  ) {
  }

  ngOnInit() {
    this.url = this.authService.userLoggedIn() ? '/user/profile' : '/register';
    this.queryParams = this.authService.userLoggedIn() ? { tab: UserProfileTab.Subscription } : { plan: RegistrationType.PERSONAL };
  }

  onButtonClick() {
    if (this.authService.userLoggedIn()) {
      if (this.userId && this.analysisId) {
        this.goToPayment();
      } else {
        this.calculatorService.saveAndPayEvent.next();
      }
    } else {
      this.router.navigate([this.url], { queryParams: this.queryParams });
    }
  }

  goToPayment() {
    window.location.href = this.paymentService.getAnalysisPaymentStripeUrl(this.paymentType, <string>this.userId, <string>this.analysisId, this.authService.getUserEmail());
  }

  onSavedPlant(savePlantResponse: SavePlantResponse) {
    this.goToPayment();
  }
}
